import type { ConfigurationRules, ResponseError } from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';
import { MINUTE_IN_MS } from 'ae-constants/constants';

import { useRendallApi } from '../use-rendall-api';

export const getConfigurationRulesQueryKey = (organizationId: string) => [
  organizationId,
  'rendall',
  'configuration-rules',
];

export function useConfigurationRules<Data = ConfigurationRules>(
  options?: Omit<
    UseQueryOptions<ConfigurationRules, ResponseError, Data>,
    'queryFn' | 'queryKey'
  >,
) {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();
  const organizationId = selectedOrganization.id;

  return useQuery({
    enabled: Boolean(organizationId),
    gcTime: 5 * MINUTE_IN_MS,
    queryFn: () => api.getConfigurationRules({ organizationId }),
    queryKey: getConfigurationRulesQueryKey(organizationId),
    ...options,
  });
}
